export default "__VITE_ASSET__BHvZ0Jy1__"